export const EMAIL_REGEX = /^[\w.-]{4,20}@[a-zA-Z]{3,10}\.[a-zA-Z]{2,10}$/;
